var render = function render(){var _vm=this,_c=_vm._self._c;return _c('widget',{attrs:{"title":_vm.$tc('words.location'),"color":"primary","subscriber":'shs-location'}},[_c('client-map',{ref:"mapRef",attrs:{"mappingService":_vm.mappingService,"edit":false,"zoom":12}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }